import { clientId } from "./init";

let injected = false;

/**
 * Injects the Pulsar tracking script.
 *
 * Mirrors the snippet the brand sites render server-side, minus data-site-id
 * which we don't have on the LP app. The endpoint/script URLs and the on/off
 * flag come from window.ini (baked in by the Helm configmap), while
 * data-client-id is the tenant resolved from the tenant configs API - so this
 * must run *after* bootstrapConfig() has completed, otherwise clientId is
 * still the DEFAULT_CLIENT_ID fallback.
 */
const loadPulsar = () => {
  if (injected) return;
  if (!window.ini?.PULSAR_ENABLED || !window.ini?.PULSAR_JS_URL) return;

  const domain = (window.location.hostname || "").toLowerCase();
  const cookieDomain = window.ini?.CLIENTS_DOMAIN?.[clientId];

  const script = document.createElement("script");
  script.src = window.ini.PULSAR_JS_URL;
  script.setAttribute("data-endpoint", window.ini.PULSAR_API_URL ?? "");
  script.setAttribute("data-client-id", clientId ?? "");
  script.setAttribute("data-domain", domain);
  if (typeof cookieDomain === "string") {
    script.setAttribute("data-cookie-domain", cookieDomain);
  }
  document.head.appendChild(script);

  injected = true;
};

export default loadPulsar;
